import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const InputEle = styled('input')(mapStylesProp);
